@let isHolder = isHolder$ | async;
@let runningScenario = runningScenario$ | async;

<div class="grid demo-grid flex-1">
  <app-card class="main">
    <div class="logo-wrapper">
      <app-logo />
    </div>
    @if (isHolder || !runningScenario) {
      <h3 class="headline">{{ "demo.intro.headline" | translate }}</h3>
      <p class="bold">{{ "demo.intro.question" | translate }}</p>
      <p>{{ "demo.intro.network" | translate }}</p>
      @if (isHolder) {
        <p>{{ "demo.intro.invitation" | translate }}</p>
        <p>{{ "demo.intro.closing" | translate }}</p>
      } @else {
        <p>{{ "demo.running.waitingHint.body" | translate }}</p>
      }
    }
    @if (isHolder) {
      <app-card class="button primary-button card-button" (click)="startDemo()">
        <app-icon name="ic_play_filled" />

        <div>
          <h3 class="uppercase line-clamp">
            {{ "demo.start.headline" | translate }}
          </h3>
          <p class="line-clamp">{{ "demo.start.subheadline" | translate }}</p>
        </div>
      </app-card>
    }

    @if (!isHolder) {
      <div class="running-scenario divider">
        <h2>{{ "demo.dialog.title" | translate }}</h2>

        @if (runningScenario) {
          @if (runningScenario.headline) {
            <p class="bold">{{ runningScenario.headline | translate }}</p>
          } @else {
            <p class="bold">{{ runningScenario.displayName }}</p>
          }

          @if (runningScenario.description) {
            <p>{{ runningScenario.description | translate }}</p>
          }

          @if (runningScenario.useCase) {
            <app-scenario-animation
              class="scenario-animation"
              [useCase]="runningScenario.useCase"
            />
          }

          <app-processing-visual
            [label]="runningScenario.displayName"
            [percent]="runningScenario.percent"
            [elapsedDisplay]="runningScenario.elapsedDisplay"
            [durationDisplay]="runningScenario.totalDisplay"
          />
        } @else {
          <p class="bold">
            {{ "demo.running.waitingHint.headline" | translate }}
          </p>
        }
      </div>
    }

    @if (isHolder) {
      <div class="group-link-wrapper divider flex gap-2 mt-auto">
        <div class="flex gap-2">
          <p>{{ "demo.invite.subheadline" | translate }}</p>
          <button
            class="button outlined-button icon-button"
            (click)="inviteGroup()"
          >
            <app-icon name="ic_user" />
            {{ "demo.invite.button" | translate }}
          </button>
        </div>

        @let remainingIdleSeconds = remainingIdleSeconds$ | async;
        @if (remainingIdleSeconds !== null) {
          <p class="idle-hint">
            {{
              "demo.idleTimeout.pageHint"
                | translate: { time: formatIdleCountdown(remainingIdleSeconds) }
            }}
          </p>
        }
      </div>
    }
  </app-card>

  @if (history$ | async; as history) {
    <app-history
      class="aside"
      [history]="history.data"
      [loading]="history.loading"
      [canLoadMore]="false"
    />
  }
</div>
